import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router';
import React from 'react';

export const routes$ = {
    Index: AsyncPageRender(() => pageModule(import('./'))),
    WholesalerProducts: AsyncPageRender(() => pageModule(import('./views/wholesaler'))),
};

function Router() {
    return (
        <>
            {redirects({
                '/wholesaler/products': () => `/wholesaler/products/skus`,
            })}
            <Route
                name={'Products.List'}
                path={'/products/:category?'}
                component={ProtectedRoute(routes$.Index, { required: null })}
            />
            <Route
                name={'Wholesaler.Products.List'}
                path={'/wholesaler/products/:tab'}
                component={ProtectedRoute(routes$.WholesalerProducts)}
            />
        </>
    );
}

export default Router;
